import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import { AppDownloadService } from '@ftr/api-core'
import { isInDesktopApp } from '@ftr/foundation'

@Component({
  selector: 'ftr-footer-help-links',
  templateUrl: './footer-help-links.component.html',
  styleUrls: ['./footer-help-links.component.css'],
  imports: [RouterLink],
  standalone: true,
})
export class FooterHelpLinksComponent {
  getDesktopUrl: string
  showDesktopDownloadLink = !isInDesktopApp()

  constructor(private readonly appDownloadService: AppDownloadService) {
    this.getDesktopUrl = this.appDownloadService.getStandaloneAppLink()
  }
}
